import * as CSS from 'csstype';

export const chameleon = 'inherit';

// orange
export const heritage = '#ff7e65';
export const heritageLight = '#ff8a74';
export const heritageDark = '#ff694b';
export const sandyButt = '#f6caa2';

//red
export const risingSun = '#ce283D';
export const littlePiggy = '#f0a9b7';

// purple
export const berlinThing = '#752873';
export const lavendork = '#b36ea7';

// blue
export const pacific = '#1f3ca6';
export const pacificLight = '#354fae';
export const pacificDark = '#1b3491';
export const carnaval = '#81a3e6';

//green
export const forrestLyf = '#2f9780';
export const mildredsCar = '#a4d2d4';

// brown
export const looseAlmond = '#95837b';
export const theTanTan = '#cbbba5';

// neutrals
export const puntRoad = '#555555';
export const puntRoadLight = '#626262'; // 0.05 lightened
export const puntRoadDark = '#484848';
export const fiftyFirstShade = '#999999';
export const pebbleBeach = '#cccccc';
export const t1000 = '#e6e6e6';
export const t1000Light = '#e8e8e8';
export const t1000Dark = '#d9d9d9';
export const karlTheFog = '#f3f2f0';
export const bleachedAs = '#ffffff';

export const semantic = {
    success: forrestLyf,
    error: risingSun,
    info: puntRoad,
    caution: berlinThing,
    callout: heritage,
    active: heritage,
};

export const typography = {
    root: puntRoad,
    heading: puntRoad,
    linkText: pacific,
    small: pebbleBeach,

    blockquote: {
        base: 'inherit',
        cite: pebbleBeach,
    },

    attribution: fiftyFirstShade,
    displayName: puntRoad,
    hr: puntRoad,
    soft: fiftyFirstShade,
    softer: pebbleBeach,
    softText: pebbleBeach,
    softIcon: t1000,
    softIconFocus: pebbleBeach,
    actionHover: pacific,
    contentBorder: t1000,
    contentBackground: bleachedAs,
};

export const vivid = {
    heritage,
    sandyButt,
    risingSun,
    littlePiggy,
    berlinThing,
    lavendork,
    pacific,
    carnaval,
    forrestLyf,
    mildredsCar,
    looseAlmond,
    theTanTan,
};

export const social = {
    twitter: '#55acee',
    facebook: '#3b5998',
    pinterest: '#bd081c',
    linkedin: '#0077b5',
};

export const packages = {
    bronze: '#e0b48c',
    silver: '#b2b2b2',
    gold: '#e8b954',
    platinum: puntRoad,
    custom: carnaval,
};

/**
 * @param color - 6-digit hex value
 * @param alpha - accepts a value between 0 and 1.0, similar to rgba()
 */
export const withAlpha = (color: string, alpha: number): string => {
    if (color[0] !== '#') {
        return color;
    }
    if (alpha < 0 || alpha > 1) {
        return color;
    }
    const alphaHex = Math.round(alpha * 255)
        .toString(16)
        .padStart(2, '0');

    return `${color}${alphaHex}`;
};

export const getColor = (color: CSS.Property.Color | Color) => {
    const exists = color in colors;
    if (exists) return colors[color as Color];
    return color;
};

export type Color =
    | 'chameleon'
    | 'heritage'
    | 'heritageLight'
    | 'heritageDark'
    | 'sandyButt'
    | 'risingSun'
    | 'littlePiggy'
    | 'berlinThing'
    | 'lavendork'
    | 'pacific'
    | 'pacificLight'
    | 'pacificDark'
    | 'carnaval'
    | 'forrestLyf'
    | 'mildredsCar'
    | 'looseAlmond'
    | 'theTanTan'
    | 'puntRoad'
    | 'puntRoadDark'
    | 'fiftyFirstShade'
    | 'pebbleBeach'
    | 't1000'
    | 't1000Light'
    | 't1000Dark'
    | 'karlTheFog'
    | 'bleachedAs';

export const colors = {
    chameleon,
    heritage,
    heritageLight,
    heritageDark,
    sandyButt,
    risingSun,
    littlePiggy,
    berlinThing,
    lavendork,
    pacific,
    pacificLight,
    pacificDark,
    carnaval,
    forrestLyf,
    mildredsCar,
    looseAlmond,
    theTanTan,
    puntRoad,
    puntRoadDark,
    fiftyFirstShade,
    pebbleBeach,
    t1000,
    t1000Light,
    t1000Dark,
    karlTheFog,
    bleachedAs,
};
